import React from "react";

// Gatsby
import { Link } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";

// Components
import SocialIcons from "./social-icons";
import OutsideLink from "./outside-link";

// Assets
import Logo from "../images/logo.png";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa"
import AvilabsIcon from '../images/avilabs-icon.png'

const routes = [
  {
    route: `/#services`,
    title: `Servicios`,
  },
  {
    route: `/research`,
    title: `Investigación`,
  },
  {
    route: `/blog`,
    title: `Blog`,
  },
  {
    route: `/equipments`,
    title: `Equipos Médicos`,
  },
  // {
  //   route: `/contact`,
  //   title: `Cursos`,
  // },
];

function Footer() {
  const isContactPage = typeof window !== "undefined" ? window.location.pathname.includes("contact") : false

  return (
    <footer className={`${isContactPage ? 'bg-light_brown' : 'bg-gray-200'}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="50 0 1350 300">
        <path fill="#fff" stroke="#85AF37" strokeWidth="3" d="M0,160L80,170.7C160,181,320,203,480,186.7C640,171,800,117,960,90.7C1120,64,1280,64,1360,64L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" />
      </svg>
      <div className="flex flex-col bg-white">
        {/* Rows container */}
        <div className="block lg:hidden flex-1 px-20">
          <Link to="/">
            <img src={Logo} className="h-auto mt-10" alt="Logo Unimel" />
          </Link>
        </div>
        <div className="flex flex-row flex-1 flex-wrap py-8 px-4 md:px-12">
          {/* Left row */}
          <div className="flex flex-row flex-1">
            {/* Left item - Unimel Logo*/}
            <div className="flex-1 p-2 hidden lg:block">
              <Link to="/">
                <img src={Logo} className="object-contain w-2/3 h-auto md:mr-5" alt="Logo Unimel" />
              </Link>
            </div>
            {/* Right item - Social Links */}
            <div className="flex-1 flex flex-col justify-start p-2">
              <p className="font-thin text-lg text-main_color lg:ml-6 md:ml-0 mt-0">Contacto</p>
              <OutsideLink overrideStyles="mt-0 pt-0" icon={<FaPhone />} text="+58 414-3186789" route="tel:+58-0414-318-6789" target="_self" />
              <OutsideLink overrideStyles="mt-0 pt-0 md:py-4" icon={<FaEnvelope />} text="unimelcitas@gmail.com" route="mailto:unimelcitas@gmail.com" />
              <AnchorLink
                className="no-underline flex flex-row h-full items-start text-gray-900 hover:text-gray-700 text-lg px-2 mt-2"
                to='/#location'>
                <FaMapMarkerAlt size={28} />
                <p className="lg:text-base text-sm my-0 ml-2">C.C. Terras Plazas, Torre Médica, Piso 11. Urb. Terrazas de Club Hípico. Caracas.</p>
              </AnchorLink>
            </div>
          </div>
          {/* Right row */}
          <div className="flex flex-row flex-1">
            {/* Left item - Contact Information */}
            <div className="flex-1 flex flex-col p-2 align-start">
              <p className="lg:text-center font-thin text-lg text-main_color mt-0">Síguenos</p>
              <SocialIcons size={22} />
            </div>
            {/* Right item - Site Navigation */}
            <nav className="flex-1 flex flex-col p-2">
              <p className="text-center font-thin text-lg text-main_color mt-0">Navegación</p>
              <div className="flex flex-col justify-start items-center">
                {routes.map(({ title, route }, i) => (
                  <Link
                    className={`text-gray-900 text-md no-underline hover:text-gray-700 ${i > 0 && 'mt-2'}`}
                    key={title}
                    to={route}>
                    {title}
                  </Link>
                ))}
              </div>
            </nav>
          </div>
        </div>
        {/* Avilabs Button */}
        <div className="px-8 items-center bg-gray-900 flex justify-end">
          <p className="text-right font-thin text-white text-sm mr-2">Developed by </p>
          <img className="h-8 w-auto mr-2" src={AvilabsIcon} />
          <p><a href="https://avilabs.dev" target="_blank" rel="noreferrer">AVILABS</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;